import { Button } from "ui2";

import { SuccessCheck } from "safety/components/attendance/SuccessCheck";

export const AlreadyOnListScreen = ({
  memberName,
  onAddAnother,
}: {
  memberName: string;
  onAddAnother: () => void;
}): React.JSX.Element => (
  <div className="tw:flex tw:flex-1 tw:flex-col tw:items-center tw:justify-center tw:gap-4 tw:p-6 tw:text-center">
    <SuccessCheck />
    <h1 className="tw:m-0 tw:text-2xl tw:font-denim tw:text-midnight">You’re already on this list</h1>
    <div className="tw:text-sm tw:text-midnight/70">{memberName} is signed in. Nothing more to do.</div>
    <Button variant="outline" onClick={onAddAnother}>
      Add someone else from this phone
    </Button>
  </div>
);
